import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Service {
    private miniSidenavSubject = new BehaviorSubject<boolean>(false);
    miniSidenav$ = this.miniSidenavSubject.asObservable();

    setMiniSidenav(state: boolean) {
        this.miniSidenavSubject.next(state);

        const layout = document.getElementById('layout-container');
        const sidenav = document.getElementById('sidenav-main');

        if (!layout || !sidenav) {
            return;
        }

        layout.classList.toggle('g-sidenav-collapsed', state);
        sidenav.classList.toggle('sidenav-mini', state);
    }
}
